import { render, staticRenderFns } from "./RegularMemberWelcome.vue?vue&type=template&id=ea38a354"
import script from "./RegularMemberWelcome.vue?vue&type=script&lang=js"
export * from "./RegularMemberWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports